import { CssBaseline, ThemeProvider } from '@mui/material'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { Done, Error, Info, Warning } from '@mui/icons-material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { inject } from 'mobx-react'
import { SnackbarProvider } from 'notistack'
import * as React from 'react'
import config from './config'
import { Shell } from './core'
import { Notifier, NotifierInfoDialog } from './core/Notifier/'
import { IStores } from './Stores'
import { createSurgicalTheme } from './SurgicalTheme'
import { createMedicalTheme } from './MedicalTheme'
import { OrganizationId } from 'src/utils/OrganizationIds'

interface IAppProps {
  isLoggedIn?: boolean
  defaultTheme?: boolean
  organizationId?: OrganizationId
  isDarkMode?: boolean
}

@inject((stores: IStores) => ({
  defaultTheme: stores.global.isSurgical,
  isLoggedIn: stores.global.isLoggedIn,
  organizationId: stores.global.currentAppOrganization?.id as OrganizationId,
  isDarkMode: stores.global.isDarkMode,
}))
class App extends React.Component<IAppProps> {
  public componentDidMount() {
    const stores = this.props as any
    if (stores.global && stores.global.initializeDarkMode) {
      stores.global.initializeDarkMode()
    }

    this.updateThemeClass()
  }

  public componentDidUpdate(prevProps: IAppProps) {
    if (prevProps.isDarkMode !== this.props.isDarkMode) {
      this.updateThemeClass()
    }
  }

  private updateThemeClass = () => {
    const { isDarkMode } = this.props
    if (isDarkMode) {
      document.documentElement.setAttribute('data-theme', 'dark')
    } else {
      document.documentElement.removeAttribute('data-theme')
    }
  }

  public render() {
    const { organizationId, isDarkMode } = this.props
    const mode = isDarkMode ? 'dark' : 'light'
    const theme =
      organizationId === OrganizationId.Surgical
        ? createSurgicalTheme(mode)
        : createMedicalTheme(mode)

    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          iconVariant={{
            error: <Error />,
            info: <Info />,
            success: <Done />,
            warning: <Warning />,
          }}
          classes={{ containerRoot: 'notistack-container-override' }}
        >
          <>
            <Notifier notificationConfig={config.NotificationConfig} />
            <NotifierInfoDialog />
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <Shell />
            </LocalizationProvider>
          </>
        </SnackbarProvider>
      </ThemeProvider>
    )
  }
}

export default App
